import { render, staticRenderFns } from "./LPAccordion.vue?vue&type=template&id=3e4f1f92&scoped=true"
import script from "./LPAccordion.vue?vue&type=script&setup=true&lang=ts"
export * from "./LPAccordion.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LPAccordion.vue?vue&type=style&index=0&id=3e4f1f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4f1f92",
  null
  
)

export default component.exports